import React, { useState, useEffect, useRef } from 'react';
import LeafletMapView from '../../osm/map/LeafletMapView';
import GoogleMapView from '../../google/map/GoogleMapView';
import { hasGoogleMapsKey } from '../../google/config';
import { useGoogleMaps } from '../../google/GoogleMapsProvider';

/**
 * Unified map component: uses Google Maps when API key is valid, else Leaflet+Esri.
 * Falls back to Leaflet on Google load error.
 */
export default function TripMap(props) {
  const [forceLeaflet, setForceLeaflet] = useState(false);
  const hasLoggedMissingKey = useRef(false);
  const { loadError } = useGoogleMaps();

  useEffect(() => {
    if (loadError) {
      console.warn('[TripMap] Google Maps failed to load (invalid key, quota, or network error). Falling back to Leaflet.', loadError);
      setForceLeaflet(true);
    }
  }, [loadError]);

  const useGoogle = hasGoogleMapsKey() && !forceLeaflet;

  if (!hasGoogleMapsKey() && !hasLoggedMissingKey.current) {
    console.info('[TripMap] REACT_APP_GOOGLE_MAPS_API_KEY not set in frontend/.env. Using Leaflet (Esri tiles).');
    hasLoggedMissingKey.current = true;
  }

  if (useGoogle) {
    return <GoogleMapView {...props} />;
  }

  return <LeafletMapView {...props} />;
}
